import { getAddress, searchForDuplicates } from 'modules/point-of-interest/service';
import * as http from 'utils/http';

const RADIUS_FOR_DUPLICATED_POI = 4;

const getLatLongValues = (feature) => {
  const [longitude, latitude] = feature?.geometry?.coordinates || [];

  return {
    longitude,
    latitude,
  };
};

const getPOIDuplicationHandler = async ({ venueName, latitude, longitude, addressId }) => {
  if (venueName && latitude && longitude) {
    return {
      text: venueName,
      latitude: latitude,
      longitude: longitude,
      radius: RADIUS_FOR_DUPLICATED_POI,
    };
  }

  if (venueName || latitude || longitude) {
    return null;
  }

  if (addressId) {
    try {
      const address = await getAddress(addressId);

      if (!address) {
        return null;
      }

      const { company_name, latitude: addressLatitude, longitude: addressLongitude } = address;

      return {
        text: company_name,
        latitude: addressLatitude,
        longitude: addressLongitude,
        radius: RADIUS_FOR_DUPLICATED_POI,
      };
    } catch (err) {
      console.error(await http.getError(err));
      return null;
    }
  }

  return null;
};

const findDuplicatedPOIs = async ({ addressId, venueName, latitude, longitude }) => {
  const matchingPOIsHandler = await getPOIDuplicationHandler({
    addressId,
    venueName,
    latitude,
    longitude,
  });

  if (!matchingPOIsHandler) {
    return undefined;
  }

  const {
    text,
    latitude: parsedLatitude,
    longitude: parsedLongitude,
    radius,
  } = matchingPOIsHandler;

  const data = await searchForDuplicates({
    text,
    latitude: parsedLatitude,
    longitude: parsedLongitude,
    radius,
  });

  return data?.features?.map((feature) => ({
    id: feature?.properties?.gid,
    name: feature?.properties?.name,
    locality: feature?.properties?.locality,
    region: feature?.properties?.region,
    ...getLatLongValues(feature),
  }));
};

export { getLatLongValues, findDuplicatedPOIs, getPOIDuplicationHandler };
